import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { AlertCircle, ArrowLeft } from "lucide-react"

export const UnexpectedError = () => (
  <div className='flex flex-col gap-10 justify-center items-center'>
    <Alert variant="destructive" className="max-w-sm">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Error</AlertTitle>
      <AlertDescription>
        No se pudo cargar la información solicitada.
      </AlertDescription>
    </Alert>
    <Button variant="outline" onClick={() => window.history.back()}>
      <ArrowLeft className="mr-2 h-4 w-4" />
      Volver
    </Button>
  </div>
)